import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
// import LoginLayout, { Input } from "../../components/LoginLayout";
// import { API_URL } from "../../apis/apiurl";
// import { API_URL } from "../../apis/apiurl";
import { useAppContext } from "../../context/appContext";
import LoginLayout, { Input } from "../../components/loginLayout";
import { graphqlRequest } from "../../services/apiService";
// import LoginLayout from "../../components/loginLayout";

const AdminLogin = () => {
  const { setPopupMessage } = useAppContext();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  // Redirect if already logged in
  useEffect(() => {
    const savedLocalStorage = JSON.parse(localStorage.getItem("maxUser"));
    const savedSessionStorage = JSON.parse(sessionStorage.getItem("maxUser"));
    const User = savedLocalStorage || savedSessionStorage;
    
    if (User?.role === "admin") {
      navigate("/createReport");
    }
  }, [navigate]);

  const loginUser = async ({ email, password }) => {
    try {
      const query = `
        mutation LoginUser {
          loginUser(email: "${email}", password: "${password}") {
            email
            token
            role
          }
        }
      `;

      const data = await graphqlRequest(query, {});
      return data.loginUser;
    } catch (error) {
      const errorMessage = error.message || "Login failed";
      setPopupMessage(errorMessage);
      throw new Error(errorMessage);
    }
  };

  const { mutate, data, isPending, error } = useMutation({
    mutationFn: loginUser,
  });

  console.log("23123123123", data);
  useEffect(() => {
    const storage = rememberMe ? localStorage : sessionStorage;
    if (data?.role === "admin") {
      storage.setItem("maxUser", JSON.stringify(data));
      navigate("/createReport");
      window.location.reload();
    } else if (data?.role === "management") {
      const payload = encodeURIComponent(JSON.stringify(data));
      const storageType = rememberMe ? "localStorage" : "sessionStorage";
      window.location.href = `https://management.maximalsecurityservices.com/?storageType=${storageType}&data=${payload}`;
    } else if (data?.role === "client") {
      const payload = encodeURIComponent(JSON.stringify(data));
      const storageType = rememberMe ? "localStorage" : "sessionStorage";
      window.location.href = `https://client.maximalsecurityservices.com/?storageType=${storageType}&data=${payload}`;
    } else if (data) {
      setPopupMessage("Wrong credentials");
    }
  }, [data, rememberMe, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email && password) mutate({ email, password });
  };

  return (
    <LoginLayout
      error={error?.message}
      loading={isPending}
      onSubmit={handleSubmit}
      title="Login"
      subtitle="Glad you’re back!"
      actionText="Login"
      links={{
        register: "register/?role=management",
        forgot: "/resetpassword",
      }}
    >
      <Input
        type="email"
        placeholder="you@example.com"
        value={email}
        label="Email"
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <Input
        type="password"
        placeholder="••••••••"
        value={password}
        label="Password"
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      <div className="flex items-center">
        <input
          type="checkbox"
          id="remember-me"
          className="mr-2 h-4 w-4 text-[#004175] focus:ring-[#004175] border-gray-300 rounded"
          checked={rememberMe}
          onChange={(e) => setRememberMe(e.target.checked)}
        />
        <label htmlFor="remember-me" className="text-sm text-gray-700">
          Remember me
        </label>
      </div>
    </LoginLayout>
  );
};

export default AdminLogin;
